// Brand flags from /register/validate-invite, resolved server-side from the invite's org.
export interface InviteBrandFlags {
  isCaddieGames?: boolean;
  isMapleCoin?: boolean;
}

/** Where a newly joined user logs in: their portal's login door (per-env), else the AskSmart login. */
export function portalLoginUrl({ isCaddieGames, isMapleCoin }: InviteBrandFlags): string {
  if (isCaddieGames) {
    return process.env.REACT_APP_CADDIEGAMES_LOGIN_URL || "https://app.caddiegames.com/";
  }
  if (isMapleCoin) {
    return process.env.REACT_APP_MAPLECOIN_LOGIN_URL || "https://app.maplecoin.ca/";
  }
  return `${process.env.REACT_APP_BACKEND_URL}/clear-and-login`;
}
